import { render, staticRenderFns } from "./HomePhoenix.vue?vue&type=template&id=6d57cd5a&"
import script from "./HomePhoenix.vue?vue&type=script&lang=js&"
export * from "./HomePhoenix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports